import React, { useMemo, useState } from "react";
import { QRCodeSVG } from "qrcode.react";

const T = {
  white: "#FFFFFF",
  offWhite: "#F5EBD9",
  black: "#1A0A00",
  grey100: "#F3ECE0",
  grey300: "#D4D3D0",
  grey500: "#8B6B50",
  grey600: "#5F5E5A",
  orange: "#E8470A",
  orangeLight: "#FDECE4",
  green: "#1A6B3C",
  red: "#DC2626",
  shadowSm: "0 1px 3px rgba(0,0,0,0.06)",
  fontBody: "'DM Sans', -apple-system, sans-serif",
  fontDisplay: "'Fraunces', Georgia, serif",
};

const orders = [
  { id: "KO-1042", customer: "Priya Sharma", items: "Aashirvaad Atta, Amul Milk, Tata Salt", total: 376, status: "New", time: "2 min ago" },
  { id: "KO-1041", customer: "Rohit Verma", items: "Maggi, Parle-G, Red Label Tea", total: 214, status: "Packing", time: "18 min ago" },
  { id: "KO-1040", customer: "Neha Gupta", items: "Fortune Oil, Sugar, Surf Excel", total: 612, status: "Out for delivery", time: "42 min ago" },
];

const products = [
  { name: "Aashirvaad Atta", stock: 18, price: 280, tag: "Popular" },
  { name: "Amul Milk", stock: 32, price: 68, tag: "Fast moving" },
  { name: "Tata Salt", stock: 8, price: 28, tag: "Low stock" },
  { name: "Maggi Masala", stock: 44, price: 14, tag: "Popular" },
  { name: "Fortune Oil", stock: 12, price: 170, tag: "Margin item" },
];

const S = {
  page: { minHeight: "100vh", background: T.offWhite, color: T.black, fontFamily: T.fontBody },
  topBar: { position: "sticky", top: 0, zIndex: 10, background: T.white, borderBottom: `1px solid ${T.grey100}`, padding: "14px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", boxShadow: T.shadowSm },
  storeName: { fontFamily: T.fontDisplay, fontSize: 20, fontWeight: 800, margin: 0 },
  demoBadge: { background: T.orangeLight, color: T.orange, borderRadius: 999, padding: "6px 11px", fontSize: 12, fontWeight: 800 },
  tabs: { display: "flex", gap: 8, overflowX: "auto", padding: "10px 20px", background: T.white, borderBottom: `1px solid ${T.grey100}` },
  tab: (active) => ({ border: `1px solid ${active ? T.black : T.grey300}`, background: active ? T.black : T.white, color: active ? T.white : T.grey500, borderRadius: 999, padding: "8px 18px", fontSize: 13, fontWeight: active ? 700 : 500, cursor: "pointer", fontFamily: T.fontBody, whiteSpace: "nowrap" }),
  body: { maxWidth: 1080, margin: "0 auto", padding: "20px 16px 56px" },
  intro: { background: T.black, color: T.white, borderRadius: 8, padding: "18px 20px", marginBottom: 18, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 18, flexWrap: "wrap" },
  introTitle: { fontFamily: T.fontDisplay, fontSize: 24, fontWeight: 800, margin: "0 0 6px" },
  introCopy: { color: "rgba(255,255,255,0.68)", fontSize: 14, lineHeight: 1.6, margin: 0 },
  cta: { background: T.orange, color: T.white, border: "none", borderRadius: 8, padding: "12px 16px", fontSize: 14, fontWeight: 800, textDecoration: "none", display: "inline-block" },
  stats: { display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(180px,1fr))", gap: 10, marginBottom: 18 },
  stat: { background: T.white, borderRadius: 8, padding: "15px 16px", boxShadow: T.shadowSm },
  statLabel: { fontSize: 11, fontWeight: 800, color: T.grey500, textTransform: "uppercase", letterSpacing: 0.6, margin: "0 0 6px" },
  statValue: { fontFamily: T.fontDisplay, fontSize: 28, fontWeight: 800, margin: 0 },
  grid: { display: "grid", gridTemplateColumns: "minmax(0,1.35fr) minmax(280px,0.65fr)", gap: 14 },
  panel: { background: T.white, borderRadius: 8, boxShadow: T.shadowSm, overflow: "hidden" },
  panelHeader: { padding: "14px 16px", borderBottom: `1px solid ${T.grey100}`, display: "flex", alignItems: "center", justifyContent: "space-between" },
  panelTitle: { fontSize: 15, fontWeight: 800, margin: 0 },
  order: { padding: "14px 16px", borderBottom: `1px solid ${T.grey100}` },
  orderTop: { display: "flex", justifyContent: "space-between", gap: 12, marginBottom: 7 },
  orderCustomer: { fontSize: 14, fontWeight: 800 },
  orderMeta: { color: T.grey500, fontSize: 12 },
  orderItems: { color: T.grey600, fontSize: 13, lineHeight: 1.5, marginBottom: 10 },
  status: (status) => {
    const color = status === "New" ? T.orange : status === "Packing" ? "#9B1C1C" : T.green;
    return { background: `${color}18`, color, borderRadius: 999, padding: "4px 9px", fontSize: 11, fontWeight: 800, whiteSpace: "nowrap" };
  },
  ghostBtn: { background: T.white, border: `1px solid ${T.grey300}`, borderRadius: 7, padding: "7px 10px", color: T.grey600, fontSize: 12, fontWeight: 700 },
  productRow: { display: "grid", gridTemplateColumns: "1fr 60px 70px", gap: 10, alignItems: "center", padding: "12px 14px", borderBottom: `1px solid ${T.grey100}`, fontSize: 13 },
  productName: { fontWeight: 800 },
  tag: { color: T.orange, background: T.orangeLight, borderRadius: 999, padding: "2px 7px", fontSize: 10, fontWeight: 800, display: "inline-block", marginTop: 4 },
  qrBox: { padding: 18, display: "grid", placeItems: "center", gap: 10, textAlign: "center" },
  qrCaption: { margin: 0, color: T.grey500, fontSize: 12 },
  toast: { position: "fixed", left: "50%", bottom: 24, transform: "translateX(-50%)", background: T.black, color: T.white, borderRadius: 999, padding: "10px 15px", fontSize: 13, boxShadow: "0 10px 30px rgba(0,0,0,0.18)" },
};

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,700;9..144,900&family=DM+Sans:wght@400;500;700;800&display=swap');
  @media (max-width: 780px) {
    .demo-grid { grid-template-columns: 1fr !important; }
  }
`;

export default function DemoDashboardPage() {
  const [tab, setTab] = useState("Orders");
  const [toast, setToast] = useState("");
  const revenue = useMemo(() => orders.reduce((sum, order) => sum + order.total, 0), []);

  const previewAction = () => {
    setToast("Demo only. Your real dashboard will update live orders.");
    window.setTimeout(() => setToast(""), 2600);
  };

  return (
    <main style={S.page}>
      <style>{CSS}</style>
      <div style={S.topBar}>
        <p style={S.storeName}>Sharma General Store</p>
        <span style={S.demoBadge}>Demo Dashboard</span>
      </div>
      <div style={S.tabs}>
        {["Orders", "Inventory", "Analytics", "QR Code"].map((item) => (
          <button key={item} type="button" style={S.tab(tab === item)} onClick={() => setTab(item)}>{item}</button>
        ))}
      </div>
      <div style={S.body}>
        <section style={S.intro}>
          <div>
            <h1 style={S.introTitle}>See how your KiranaOS dashboard works.</h1>
            <p style={S.introCopy}>Track orders, manage stock, view sales, and share your customer QR from one mobile-friendly dashboard.</p>
          </div>
          <a style={S.cta} href="/onboarding">Set up my store</a>
        </section>

        <div style={S.stats}>
          <div style={S.stat}><p style={S.statLabel}>Orders today</p><p style={S.statValue}>{orders.length}</p></div>
          <div style={S.stat}><p style={S.statLabel}>Revenue today</p><p style={S.statValue}>Rs {revenue}</p></div>
          <div style={S.stat}><p style={S.statLabel}>Active products</p><p style={S.statValue}>{products.length}</p></div>
          <div style={S.stat}><p style={S.statLabel}>Store status</p><p style={{ ...S.statValue, color: T.green }}>Live</p></div>
        </div>

        {tab === "Orders" && (
          <div style={S.grid} className="demo-grid">
            <section style={S.panel}>
              <div style={S.panelHeader}><p style={S.panelTitle}>Live Orders</p><span style={S.demoBadge}>Sample data</span></div>
              {orders.map((order) => (
                <div style={S.order} key={order.id}>
                  <div style={S.orderTop}>
                    <div>
                      <div style={S.orderCustomer}>{order.customer}</div>
                      <div style={S.orderMeta}>{order.id} / {order.time}</div>
                    </div>
                    <span style={S.status(order.status)}>{order.status}</span>
                  </div>
                  <div style={S.orderItems}>{order.items}</div>
                  <button type="button" style={S.ghostBtn} onClick={previewAction}>Preview status update</button>
                </div>
              ))}
            </section>
            <section style={S.panel}>
              <div style={S.panelHeader}><p style={S.panelTitle}>What owner sees</p></div>
              <div style={{ padding: 16, color: T.grey600, fontSize: 14, lineHeight: 1.7 }}>
                New orders appear here instantly. The owner can accept, pack, mark delivery, and see customer details in one place.
              </div>
            </section>
          </div>
        )}

        {tab === "Inventory" && (
          <section style={S.panel}>
            <div style={S.panelHeader}><p style={S.panelTitle}>Inventory Preview</p><button type="button" style={S.ghostBtn} onClick={previewAction}>Add product</button></div>
            {products.map((product) => (
              <div style={S.productRow} key={product.name}>
                <div><div style={S.productName}>{product.name}</div><span style={S.tag}>{product.tag}</span></div>
                <div>{product.stock} left</div>
                <div>Rs {product.price}</div>
              </div>
            ))}
          </section>
        )}

        {tab === "Analytics" && (
          <section style={S.panel}>
            <div style={S.panelHeader}><p style={S.panelTitle}>Sales Snapshot</p></div>
            <div style={{ padding: 18, display: "grid", gap: 14 }}>
              {["Best seller: Aashirvaad Atta", "Peak order time: 6 PM - 9 PM", "Repeat customers: 14 this week", "Low stock alerts: 1 product"].map((item) => (
                <div style={{ background: T.offWhite, borderRadius: 8, padding: 14, fontWeight: 700 }} key={item}>{item}</div>
              ))}
            </div>
          </section>
        )}

        {tab === "QR Code" && (
          <section style={S.panel}>
            <div style={S.panelHeader}><p style={S.panelTitle}>Customer QR</p></div>
            <div style={S.qrBox}>
              <QRCodeSVG value="https://kiranaos.in/store/demo-store" size={190} bgColor="#ffffff" fgColor="#1A0A00" level="M" />
              <p style={S.qrCaption}>Customers scan this to open your store and place orders.</p>
              <a style={S.cta} href="/store/demo-store">Open customer demo</a>
            </div>
          </section>
        )}
      </div>
      {toast && <div style={S.toast}>{toast}</div>}
    </main>
  );
}
